import React, { Fragment } from 'react';
// import About from './components/About';
import Section from '../../Section/Section';
import MeetingForm from '../../../components/Form/MeetingForm';
import aboutMeImg from '../../../assets/img/me/mePhoto.png'


const AboutComponent = () => {
  return (
    <Section>
    {/* <Fade delay={300} direction="right"> */}
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-1 my-10 mt-16 mb-10">
      <div className="col-span-1 md:col-span-1 xl:col-span-2 flex flex-col justify-center xl:ml-6">
        <h2 className="text-5xl xl:text-4xl text-center xl:text-start  text-primary font-bold uppercase">
            Sobre mí
          </h2>
        <div className='grid grid-cols-1 xl:grid-cols-2'>
          <div className="col-span-2 xl:col-span-1 flex justify-center flex-col">
            <img
              src={aboutMeImg}
              alt="about-img"
              className="object-cover object-center rounded-full shadow-lg h-[280px] w-[280px] mt-10 mx-20 md:mx-2 md:w-[300px] md:h-[300px] xl:w-[350px] xl:h-[350px] xl:my-10 xl:mx-20 hover:scale-110 duration-300"
            />
          </div>
          <div className="col-span-2 xl:col-span-1 ">
            <p className="text-lg xl:text-xl text-gray-700 mt-8 ml-0 xl:ml-1 xl:text-left">               
              Con una trayectoria sólida que se remonta a 1989, nuestra corredora se ha destacado 
              en el mercado inmobiliario por su compromiso con la excelencia en la compraventa y 
              arriendo de una amplia gama de propiedades, que van desde inmuebles particulares hasta 
              locales comerciales, terrenos e inmuebles destinados a instituciones estatales. 
              Contamos con un equipo de profesionales altamente capacitados en estudio de títulos, 
              posesiones efectivas y tasaciones, respaldados por una extensa red nacional que nos 
              permite operar en todo el país.
              <br />
              <br />
              Nuestro enfoque se centra en la rapidez y la seriedad en cada transacción, 
              buscando siempre satisfacer las necesidades de las familias que confían en 
              nosotros para encontrar su primer hogar o invertir en propiedades. 
              Nos enorgullece ofrecer un servicio que no solo facilita la búsqueda 
              de viviendas, sino que también brinda apoyo y orientación integral 
              a nuestros clientes, ayudándolos a hacer realidad sus sueños inmobiliarios.
            </p>
            <p className="text-lg xl:text-xl text-gray-700 mt-8 ml-0 xl:ml-1 md:text-center xl:text-left">
              Jara pinto.
            </p>
            <p className="text-xl xl:text-xl text-gray-700 ml-0 xl:ml-1 md:text-center xl:text-left">
              Fundadora de Jara Pinto Corredores Asociados SpA.
            </p>
          </div>
        </div>
      </div>
    </div>
    {/* </Fade>  */}
  </Section>
  );
};

export default AboutComponent;
